/**
 * @flow
 * @relayHash b5bafa516c726c61f78ecdc0eaa130b3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GetStravaAccessTokenInput = {|
  code: string
|};
export type GetStravaAccessTokenMutationVariables = {|
  input: GetStravaAccessTokenInput
|};
export type GetStravaAccessTokenMutationResponse = {|
  +getStravaAccessToken: ?{|
    +accessToken: string
  |}
|};
export type GetStravaAccessTokenMutation = {|
  variables: GetStravaAccessTokenMutationVariables,
  response: GetStravaAccessTokenMutationResponse,
|};
*/


/*
mutation GetStravaAccessTokenMutation(
  $input: GetStravaAccessTokenInput!
) {
  getStravaAccessToken(input: $input) {
    accessToken
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "GetStravaAccessTokenInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getStravaAccessToken",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GetStravaAccessTokenPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "accessToken",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GetStravaAccessTokenMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GetStravaAccessTokenMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GetStravaAccessTokenMutation",
    "id": null,
    "text": "mutation GetStravaAccessTokenMutation(\n  $input: GetStravaAccessTokenInput!\n) {\n  getStravaAccessToken(input: $input) {\n    accessToken\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '56d64ff90e3f3f4cfb60b7a7e28415f5';

module.exports = node;
